const sanitizedNumber = number => number.replace(/[\s()-]/g, '');

export default sanitizedNumber;
